import $api from "..";
import { AxiosResponse } from "axios";
import { IPersonWithStatus } from "../common/api_interfaces/user/IPersonWithStatus";
import { IUserStatus } from "../common/api_interfaces/user/IUserStatus";
import { UserWithSessions } from "../common/api_interfaces/user/UserWithSessions";
import { IPersonalSettings } from "../common/api_interfaces/user/IPersonalSettings";
import { IToken, ITokenPost } from "../common/api_interfaces/token/IToken";
import { IPersonRole } from "../common/api_interfaces/user/IPersonRole"
import { IGetAllUsersWithSystemRoles } from "../common/api_interfaces/user/IGetAllUsersWithSystemRoles";
import { IEditPersonalSettingsRequest } from "../common/api_interfaces/user/IEditPersonalSettings";
import { IGetAllUsers } from "../common/api_interfaces/user/IGetAllUsers";
import { IEditUser } from "../common/api_interfaces/user/IEditUser";
import { IFullUserInfo, IUserInfo } from "../common/api_interfaces/user/IUserInfo";

export default class UserService {
    async getAllUsers(reqBody: IGetAllUsers): Promise<AxiosResponse<IFullUserInfo[]>> {
        return $api.post<IFullUserInfo[]>(`/getAllUsers`, reqBody);
    }

    static async getAllUserStatuses(): Promise<AxiosResponse<IUserStatus[]>> {
        return $api.get<IUserStatus[]>("/getAllUserStatuses");
    }

    static async getDataLinkPerson(link: string): Promise<AxiosResponse<IPersonWithStatus>> {
        return $api.get<IPersonWithStatus>(`/getDataLinkPerson?link=${link}`);
    }

    static getSystemPersonWithRoles(): Promise<AxiosResponse<IPersonRole>> {
        return $api.get<IPersonRole>("/getActivePersonWithRoles");
    }

    async getAllUsersWithSystemRoles(
    ): Promise<AxiosResponse<IGetAllUsersWithSystemRoles[]>> {
        return $api.get<IGetAllUsersWithSystemRoles[]>(`System/personWithRoles`);
    }

    static async getUser(userId: number): Promise<AxiosResponse<IFullUserInfo>> {
        return $api.get<IFullUserInfo>(`/getUser?userId=${userId}`);
    }

    async editPersonalInfo(body: IEditUser): Promise<AxiosResponse<IUserInfo>> {
        return $api.post<IUserInfo>("/editPersonalInfo", body);
    }

    static async getPersonalSettings(): Promise<AxiosResponse<IPersonalSettings[]>> {
        return $api.get<IPersonalSettings[]>("/getPersonalSettings");
    }

    static async editPersonalSettings(body: IEditPersonalSettingsRequest): Promise<AxiosResponse<IPersonalSettings[]>> {
        return $api.post<IPersonalSettings[]>("/editPersonalSettings", body);
    }

    async getSessions(): Promise<AxiosResponse<UserWithSessions[]>> {
        return $api.get<UserWithSessions[]>("/user/session");
    }

    async deleteSession(body: string[]): Promise<AxiosResponse<string[]>> {
        return $api.post<string[]>("/user/session/delete", body);
    }

    static async getSuperAdminsEmails(): Promise<AxiosResponse<string[]>> {
        return $api.get<string[]>("/System/getSuperAdminsEmails");
    }
    static async getToken(): Promise<AxiosResponse<IToken>> {
        return $api.get<IToken>("/token");
    }
    static async generateToken(body: ITokenPost): Promise<AxiosResponse<IToken>> {
        return $api.post<IToken>("/generateToken", body);
    }
    static async deleteToken(body: ITokenPost): Promise<AxiosResponse<string[]>> {
        return $api.post<string[]>("/deleteToken", body);
    }
}
